import { useQuery, useQueryClient } from '@tanstack/react-query';

import { AssignmentGatewayMessage } from '../../../../types/AssignmentGatewayMessage';
import { AssignmentStatus } from '../../../../types/AssignmentMessage';
import { queries } from '../../../common/api/queryKeys/queries';

export const useAssignmentList = (customerId?: string, portId?: string, testOrder?: boolean) => {
    const queryClient = useQueryClient();

    const query = useQuery({
        ...queries.assignments.list({ customerIds: customerId ? [customerId] : undefined }),
        enabled: !!customerId,
        select: (assignments: AssignmentGatewayMessage[]) => {
            return assignments
                .filter((assignment) => {
                    // Lubes assignments do not have port limitations and should not be filtered out
                    if (!assignment.portLimitations?.length) {
                        return true;
                    }

                    // If there is no provided portId, no need to filter.
                    if (!portId) {
                        return true;
                    }

                    return assignment.portLimitations.some((limitationPortId) => limitationPortId === portId);
                })
                .filter((assignment) => assignment.supplier?.testCompany === testOrder)
                .filter((assignment) => assignment.status === AssignmentStatus.CONFIRMED);
        },
    });

    const prefetch = (customerId) => {
        queryClient.prefetchQuery(queries.assignments.list({ customerIds: [customerId] }));
    };

    return {
        ...query,
        prefetch,
    };
};
